import { CollectionChainType } from '../common';

export function getChainFromIndex(chainIndex: 0 | 1 | 2) {
    switch (chainIndex) {
        case 2:
            return CollectionChainType.Aptos;
        case 1:
            return CollectionChainType.Polygon;
        case 0:
        default:
            return CollectionChainType.Ethereum;
    }
}

export function getChainFromWagmiChainId(chainId: number) {
    switch (chainId) {
        case 137:
            return 'polygon';
        case 5:
        case 11_155_111:
        case 1:
            return 'ethereum';
        default:
            // TODO: find out about the about chain id
            return 'aptos';
    }
}
